import { useQuery } from "@tanstack/react-query"
import { type RouterOutputs, useTRPC } from "utils/trpc"

export type MetricConfiguration =
  RouterOutputs["metrics"]["getMetricsConfiguration"]["data"][number]

const useMetricsConfiguration = () => {
  const trpc = useTRPC()
  return useQuery(trpc.metrics.getMetricsConfiguration.queryOptions())
}

export default useMetricsConfiguration
